import React from "react";
import {  useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import {  checkIsRool } from "./features/redux/authSlice";
import { routeItems } from "./util/rool";

import { Layout } from "./components/Layout";
import ServerOffline from "./components/ServerOffline";
import Loading from "./components/Loading";

function App() {
  
  const userRole = useSelector(checkIsRool);
  const isServerOffline = useSelector((state) => state.socket.isServerOffline);

  return (
    <React.Fragment>
      {isServerOffline && <ServerOffline />}
     <Layout>
        <Routes>
          {routeItems[userRole].map((Elem) =>
            [Elem.route].map((path) => (
              <Route path={path} key={path} element={Elem.tag} />
            ))
          )}
        </Routes>
      </Layout>
    </React.Fragment>
  );
}

export default App;
